module.exports = __webpack_public_path__ + "img/clue02_bg.09cf7f32.png";